import React, { useEffect } from 'react';

import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';

import { AdminHeader } from '../components/admin/AdminHeader';
import { MemberList } from '../components/admin/members/MemberList';
import { useMemberStore } from '../stores/memberStore';
import { hideGlobalLoading, showGlobalLoading } from '../hooks/useLoading';

export function AdminDashboard() {
  const { isLoading, loadMembers } = useMemberStore();

  useEffect(() => {
    loadMembers();
  }, []);

  useEffect(() => {
    if(isLoading) {
      showGlobalLoading()
    } else {
      hideGlobalLoading();
    }
  }, [isLoading]);

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <AdminHeader />
          <MemberList />
        </div>
      </div>
      <Footer />
    </>
  );
}